import React, { useEffect, useState, useRef } from "react";
import {
  CardBody,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Label,
  Input,
  Card,
  CardHeader,
  CardTitle,
  Col,
  Row,
  Container,
  Button,
} from "reactstrap";
import { showLoading } from "react-global-loading";
import classnames from "classnames";
import { Link, useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import StandardList from "./StandardList";
import ServiceList from "./ServiceList";
import MustCoverList from "./MustCoverList";
import "./Standards.scss";
import FeatherIcon from "feather-icons-react";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import { Toolbar } from "../../components/Common/LegacyGridAdapter";

//Import Icons

// //Import Scrollbar

const StandardIndex = () => {
  const [activeTab, setactiveTab] = useState(1);
  const [active, setActive] = useState("1");
  const [newStandardRequest, setNewStandardRequest] = useState(0);
  const [newServiceCodeRequest, setNewServiceCodeRequest] = useState(0);
  const [newMustCoverCodeRequest, setNewMustCoverCodeRequest] = useState(0);
  const ref = useRef();

  useEffect(() => {
    //var menu = new MetisMenu("#sub-menu");
  }, []);

  const showOverview = (even) => {
    setactiveTab(1);
  };

  const showActivity = (even) => {
    setactiveTab(2);
  };

  const showConversation = (even) => {
    setactiveTab(3);
  };

  const showContacts = (even) => {
    setactiveTab(4);
  };

  const showDeals = (even) => {
    setactiveTab(5);
  };

  const showFiles = (even) => {
    setactiveTab(6);
  };

  return (
    <React.Fragment>
      <div className="page-content standards-page piers-page">
        <Container fluid>
          <header className="standards-page__header piers-page-header">
            <div>
              <h1 className="piers-page-title">Standards</h1>
              <p>
                Manage inspection standards and frameworks used in audits and
                reviews.
              </p>
            </div>
            <button
              type="button"
              className="standards-page__create"
              onClick={() => {
                if (activeTab === 1)
                  setNewStandardRequest((request) => request + 1);
                if (activeTab === 2)
                  setNewServiceCodeRequest((request) => request + 1);
                if (activeTab === 3)
                  setNewMustCoverCodeRequest((request) => request + 1);
              }}
            >
              <i className="bx bx-plus" />{" "}
              {activeTab === 1
                ? "New Standard"
                : activeTab === 2
                ? "New Service Code"
                : "New Must Cover Code"}
            </button>
          </header>
          <CardBody className="standards-page__body">
            <div id="basic-pills-wizard" className="twitter-bs-wizard">
              <Nav tabs className="standards-page__tabs">
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 1 })}
                    onClick={() => {
                      setactiveTab(1);
                    }}
                  >
                    <span>Standards</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 2 })}
                    onClick={() => {
                      setactiveTab(2);
                    }}
                  >
                    <span>PRIMA Service Codes</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 3 })}
                    onClick={() => {
                      setactiveTab(3);
                    }}
                  >
                    <span>PRIMA Must Cover Codes</span>
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent
                className="twitter-bs-wizard-tab-content standards-page__tabs-content"
                style={{ paddingTop: "10px" }}
                activeTab={activeTab}
              >
                <TabPane tabId={1}>
                  <StandardList createRequest={newStandardRequest} />
                </TabPane>
                <TabPane tabId={2}>
                  <ServiceList createRequest={newServiceCodeRequest} />
                </TabPane>
                <TabPane tabId={3}>
                  <MustCoverList createRequest={newMustCoverCodeRequest} />
                </TabPane>
              </TabContent>
            </div>
          </CardBody>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default StandardIndex;
